module.exports = __webpack_public_path__ + "img/party.589f8fc4.svg";